module.exports = __webpack_public_path__ + "img/high_five.8a620164.svg";